// /src/utils/fetchConversationData.js

import ConversationStructure from "../Constants/UserMessagingConversationHist";

export const fetchConversationData = async () => {
  try {
    const response = await fetch("/api/mock/AccountPage/UserAccountMessageHistoryMock.json"); // path in public folder
    const rawData = await response.json();

    // Validate & structure the data
    const formattedData = {
      conversations: (rawData.conversations || []).map((entry) => ({
        month: entry.month || "",
        allmessages: (entry.allmessages || []).map((msgDay) => ({
          date: msgDay.date || "",
          messages: (msgDay.messages || []).map((msg) => ({
            id: msg.id || "",
            sender: msg.sender || "",
            content: msg.content || "",
            timestamp: msg.timestamp || ""
          }))
        }))
      }))
    };

    return formattedData;
  } catch (error) {
    console.error("Failed to fetch conversation data:", error);
    return ConversationStructure; // Return empty/fallback structure on error
  }
};

export default fetchConversationData